import React from 'react'
import './Popup.css'

function Popup(props){
    if(props.afterClose && !props.trigger){
        props.afterClose();
    }
    if(props.afterOpen && props.trigger){
        props.afterOpen();
    }    
    return(props.trigger) ? (
        <div className="popup">
            <div className="popup-inner">
                {props.children}
            </div>
        </div>
    ) :"";
}
export default Popup;